const styles = {
  bar: {
    minWidth: 0,
    display: 'grid',
    gridTemplateColumns: '187px 170px 170px',
    gap: 1,
    overflowX: 'auto',
    scrollbarWidth: 'none',
  },
};

export default styles;
